/**
 * @file config.ts
 * @description Конфигурационный модуль Axios для Task Manager приложения, который создает настроенный HTTP-клиент с автоматической обработкой аутентификации и обновления токенов. Включает interceptors для автоматического добавления Bearer токенов в заголовки запросов, обработку 401 ошибок с автоматическим обновлением access token через refresh token, управление localStorage для хранения токенов и их сроков действия, автоматический редирект на страницу логина при неудачном обновлении токенов.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['axios']
 * @related-files ['src/api/actions.ts', 'src/features/auth/auth-slice.ts', 'src/pages/login/login.component.tsx']
 */

import axios, { AxiosRequestConfig } from 'axios';

const instance = (extraConfig?: AxiosRequestConfig) => {
    const defaultOptions: AxiosRequestConfig = {
        baseURL: import.meta.env.VITE_API_URL,
        ...extraConfig
    };

    // Create instance
    let instance = axios.create(defaultOptions);

    // Set the AUTH token for any request
    instance.interceptors.request.use((config) => {
        const token = localStorage.getItem(`${import.meta.env.VITE_BASE_URL}_accessToken`);

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    });

    instance.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const originalRequest = error.config;

            if (error?.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                const refreshToken = localStorage.getItem(`${import.meta.env.VITE_BASE_URL}_refreshToken`);

                if (refreshToken) {
                    try {
                        const response = await axios.post(`${import.meta.env.VITE_API_URL}account/token-refresh`, {
                            refreshToken
                        });
                        // don't use axious instance that already configured for refresh token api call
                        const newAccessToken = response.data.accessToken;
                        localStorage.setItem(`${import.meta.env.VITE_BASE_URL}_accessToken`, newAccessToken); //set new access token
                        localStorage.setItem(
                            `${import.meta.env.VITE_BASE_URL}_accessTokenExpiresAt`,
                            response.data.accessTokenExpiresAt
                        ); //set new access token
                        localStorage.setItem(
                            `${import.meta.env.VITE_BASE_URL}_refreshToken`,
                            response.data.refreshToken
                        ); //set new access token
                        localStorage.setItem(
                            `${import.meta.env.VITE_BASE_URL}_refreshTokenExpiresAt`,
                            response.data.refreshTokenExpiresAt
                        ); //set new access token
                        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

                        return axios(originalRequest); //recall Api with new token
                    } catch (error) {
                        // Handle token refresh failure
                        // mostly logout the user and re-authenticate by login again
                        localStorage.removeItem(`${import.meta.env.VITE_BASE_URL}_accessToken`);
                        window.location.href = `${import.meta.env.VITE_BASE_URL}login`;
                    }
                }
            } else {
                //set error
            }

            return Promise.reject(error);
        }
    );

    return instance;
};

export default instance;
